<template>
  <div id="footer" class="footer" :style="'opacity:' + opacity + ';display:' + display + ';'">
    <div id="illustration-logo-container" class="footer-parts">
      <img id="illustration-logo" src="../assets/illustration-tnoir.png" alt="illustration du logo">
    </div>
    <div class="footer-parts">
      <router-link to="/app"><div class="footer-link">Télécharger l'application</div></router-link>
      <router-link to="/contact"><div class="footer-link">Nous contacter</div></router-link>
      <router-link to="/bug"><div class="footer-link">Signaler un bug</div></router-link>
      <router-link to="/privacy"><div class="footer-link">Politique de confidentialité</div></router-link>
      <router-link to="/cgu"><div class="footer-link">Mentions légales</div></router-link>
    </div>
    <div class="footer-parts" id="light_button_part">
      <DarkLightModeButton/>
    </div>
  </div>
</template>


<style scoped>
  #footer {
    height: 112px;
    width: 100%;
    padding: 27px 0 20px;
    margin-top: 30px;

    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    background-color: var(--color-footer-1);
    box-shadow: inset 0 55px 30px -50px var(--color-footer-2);
    transition: background var(--transition-duration-color), box-shadow var(--transition-duration-color);
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-shrink: 0;
  }
  .footer-parts {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    position: relative;
  }
  .footer-link {
    color: var(--color-text-1);
    transition: var(--transition-duration-color);
    cursor: pointer;
  }
  .footer-link:hover {
    text-decoration: underline;
  }

  #light_button_part {
    width: 120px;
  }
  #illustration-logo {
    height: 140px;
    opacity: .2;
  }

  @media screen and (max-width: 720px) {
    .footer-parts {
      padding-left: 10px;
      text-align: center;
    }
    #illustration-logo-container {
      display: none;
    }
  }

</style>

<script>
  import DarkLightModeButton from '/src/components/DarkLightModeButton.vue'

  export default {
    name: 'home',
    data() {
      return {
        opacity: 100,
        display: ''
      }
    },
    components: {DarkLightModeButton},
    watch:{
      $route (route){
        if (route.path.includes('/quiz') || route.path.includes('/test')) {
          this.opacity = 0
          this.display = 'none'
        }
        else {
          this.opacity = 100
          this.display = ''
        }
      }
    }
  }
</script>